export const LANGUAGES = ['en', 'ru', 'es', 'de', 'fr', 'pt', 'it'];
